export class EndpointSpec {
    argParser;
    resultParser;
    _name;
    constructor(
    //
    argParser, resultParser) {
        this.argParser = argParser;
        this.resultParser = resultParser;
    }
    get name() {
        if (this._name == undefined) {
            throw new Error(`Name has not been set!`);
        }
        return this._name;
    }
    set name(newName) {
        this._name = newName;
    }
}
//# sourceMappingURL=EndpointSpec.js.map